export default __webpack_public_path__ + "static/media/clock.2ac6eb16.svg";